import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Card de métrica para el tablero admin con título, valor y CTA opcional.
 */
export default function StatCard({ title, value, ctaLabel, ctaTo, icon }) {
  const navigate = useNavigate();

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-sm font-medium text-slate-500">{title}</p>
          <p className="text-2xl font-bold text-slate-900 mt-1">{value}</p>
        </div>
        {icon && <span className="text-2xl text-slate-400">{icon}</span>}
      </div>
      {ctaLabel && ctaTo && (
        <button
          type="button"
          onClick={() => navigate(ctaTo)}
          className="mt-4 text-sm font-medium text-blue-600 hover:text-blue-800"
        >
          {ctaLabel} →
        </button>
      )}
    </div>
  );
}
